export const clamp = (num: any, min: number, max: number) =>
  Math.min(Math.max(num, min), max);
